




























































import Vue from 'vue'
import Block from '@/components/Block.vue'
import {Flicking} from "@egjs/vue-flicking";

export default Vue.extend({
  name: 'FloatingStepsDesktop',
  components: {
    Block,
    Flicking
  },
  props: {
    mainGoals: {
      type: Array,
    },
  },
  computed: {
    flickingOptions(): object {
      return {
        align: {
          camera: (this as any).$vuetify.breakpoint.width > 455 ? '15%' : '20%',
          panel: '20%'
        }
      }
    }
  },
  data: () => ({
    dialogs: [],
  }),
})
